import View from './View';

export { default as View, getTextLinkStyles } from './View';

export default View;
